<template>
  <div class="xm-sidebar">
    <div
      v-for="route in menus"
      :key="route.title"
    >
      <router-link :to="route.path">
        {{ route.title }}
      </router-link>
    </div>
  </div>
</template>
<script>
  import I18n from '@i18n'

  const isOkki = window.location.href.includes('okki.com');
  const MENUS = [
    {
      title: I18n.t('sideBar.home'),
      name: '',
      path: '/home',
      index: '1',
    },
    {
      title: I18n.t('sideBar.buy'),
      name: '',
      path: '/store',
      index: '2',
      hideInTaiWan: true,
    },
    {
      title: I18n.t('sideBar.order'),
      name: '',
      path: '/order',
      index: '3',
    },
    {
      title: I18n.t('sideBar.voucher'),
      name: '',
      path: '/voucher',
      index: '4',
      hideInTaiWan: true,
    },
  ]

  export default {
    data () {
      return {
        selected: ['1'],
        menus : MENUS.filter(menu => !(isOkki && menu.hideInTaiWan))
      }
    },
    watch: {
      '$route'(route) {
        const currentPath = route.path
        MENUS.forEach(menu => {
          const pathReg = new RegExp(menu.path)
          if (pathReg.test(currentPath)) {
            this.selected = [menu.index]
            return
          }
        })
      }
    },
    methods: {
      onClick(menu) {
        this.selected = [menu.index]
        this.$router.push(menu.path)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .xm-sidebar{
    position: fixed;
    top: 66px;
    z-index: 29;
    width: 200px;
    height: calc(100vh - 66px);
    margin-left: -200px;
    border-right: 1px solid #b6b6b6;
    background: #fff;
    a{
      display: block;
      padding: 0 20px;
      font-size: 14px;
      line-height: 40px;
      color: #444;
      &:hover{
        background-color: #f0f0f0;
        text-decoration: none !important;
      }
      &.router-link-active{
        color: #0884f3;
        background: #ecf4fd;
      }
    }
  }
</style>

